import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { GooglePlaceModule } from "ngx-google-places-autocomplete";


import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { AboutComponent } from './about/about.component';
import { SearchComponent } from './search/search.component';
import { LoginComponent } from './login/login.component';
import { TeacherDetailsComponent } from './teacher-details/teacher-details.component';
import { FaqComponent } from './faq/faq.component';
import { SearchResultsComponent } from './search-results/search-results.component';
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { HomeComponent } from './home/home.component';
import { ProfileComponent } from './profile/profile.component';;
import {HttpClient, HttpClientModule} from '@angular/common/http';
import { FormsModule , ReactiveFormsModule} from '@angular/forms';
import {DashboardComponent} from './dashboard/dashboard.component';
import {EnrollComponent} from './enroll/enroll.component';
import {AssignmentComponent} from './assignment/assignment.component';
import {AssessmentComponent} from './assessment/assessment.component';
import {NoticeComponent} from './notice/notice.component';
import {EnquiryComponent} from './enquiry/enquiry.component';
import {ContentComponent} from './content/content.component';
import {UserProfileComponent} from './user-profile/user-profile.component';
import {EnrolDetailsComponent} from './enrol-details/enrol-details.component';
import {NoticeListComponent} from './notice-list/notice-list.component';
import {NoticeDetailsComponent} from './notice-details/notice-details.component';
import {ContentListComponent} from './content-list/content-list.component';
import {ContentDetailsComponent} from './content-details/content-details.component';
import { ClassSearchResultComponent } from './class-search-result/class-search-result.component';
import { ViewSearchDetailsComponent } from './view-search-details/view-search-details.component';
import { ViewSearchComponent } from './view-search/view-search.component';
import { MyCoursesComponent } from './my-courses/my-courses.component';
import {ClassDetailsComponent} from './class-details/class-details.component';
import {RegistrationComponent} from './registration/registration.component';
import {OtpComponent} from './otp/otp.component';
import {MakeEnquriyComponent} from './make-enquriy/make-enquriy.component';
import {MakeEnrollComponent} from './make-enroll/make-enroll.component';
import {ClassSearchDetailsComponent} from './class-search-details/class-search-details.component';
import {HowitworksComponent} from './howitworks/howitworks.component';
import {SuccessEnquriyComponent} from './success-enquriy/success-enquriy.component';
import {AboutUsComponent} from './about-us/about-us.component';
import { CalendarComponent } from './calendar/calendar.component';
import { ContactusComponent } from './contactus/contactus.component';
import { TermsComponent } from './terms/terms.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import {EnquiryDetailsComponent} from './enquiry-details/enquiry-details.component';
import {CookieService} from 'ngx-cookie-service';
import {NgcCookieConsentModule, NgcCookieConsentConfig} from 'ngx-cookieconsent';
import { UsereditComponent } from './useredit/useredit.component';
import { HowItWorksTeacherComponent } from './how-it-works-teacher/how-it-works-teacher.component';
import { AppDownloadComponent } from './app-download/app-download.component';
import { CreatePostComponent } from './create-post/create-post.component';
import { DClsDtlsComponent } from './d-cls-dtls/d-cls-dtls.component';
import { CookieLawModule } from 'angular2-cookie-law';
import { MyPostComponent} from './my-post/my-post.component';
import { SuccessPostComponent } from './success-post/success-post.component';
import { TransferHttpCacheModule } from '@nguniversal/common';
import {TranslateModule, TranslateLoader} from '@ngx-translate/core';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import { CommonModule } from '@angular/common';
import { TeacherResponceComponent } from './teacher-responce/teacher-responce.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { AssesmentDetailsComponent } from './assesment-details/assesment-details.component';
import {AssignmentDetailsComponent} from './assignment-details/assignment-details.component';
import {SubmissionDetailsComponent} from './submission-details/submission-details.component';
import {SuccessEnrollComponent} from './success-enroll/success-enroll.component';
import { COOKIEURL, environment } from '../environments/environment';
import { ServiceWorkerModule } from '@angular/service-worker';
import { HomeScreenNewComponent } from './home-screen-new/home-screen-new.component';
import { AvailableClassesSliderComponent } from './home-screen-new/available-classes-slider/available-classes-slider.component';
import { HomeSearchFormComponent } from './home-screen-new/home-search-form/home-search-form.component';
import { ClassSearchResultNewComponent } from './class-search-result-new/class-search-result-new.component';
import { SearchFiltersComponent } from './class-search-result-new/search-filters/search-filters.component';
import { SearchListComponent } from './class-search-result-new/search-list/search-list.component';
import { SearchItemsComponent } from './class-search-result-new/search-list/search-items/search-items.component';






const cookieConfig:NgcCookieConsentConfig = {
  cookie: {
    //domain: 'localhost' // or 'your.domain.com' // it is mandatory to set a domain, for cookies to work properly (see https://goo.gl/S2Hy2A)
    domain: COOKIEURL
  },
  position: 'bottom',
  palette: {
    "popup": {
      "background": "#000000",
      "text": "#ffffff"
    },
    "button": {
      
      "background": "#f1d600",
      "text": "#000000"
    }
  },
  theme: 'classic',
  type: 'opt-out',
  layouts: {
    "my-custom-layout": '{{messagelink}}{{compliance}}'
  },
  elements:{
    messagelink: `
    <span id="cookieconsent:desc" class="cc-message">{{message}} 
      <a aria-label="learn more about cookies" tabindex="0" class="cc-link" href="{{cookiePolicyHref}}" target="_blank">{{cookiePolicyLink}}</a>, 
      <a aria-label="learn more about our privacy policy" tabindex="1" class="cc-link" href="{{privacyPolicyHref}}" target="_blank">{{privacyPolicyLink}}</a> and our 
      <a aria-label="learn more about our terms of service" tabindex="2" class="cc-link" href="{{tosHref}}" target="_blank">{{tosLink}}</a>
    </span>
    `,
  },
  content:{
    message: 'By using our site, you acknowledge that you have read and understand our ',
    
    cookiePolicyLink: 'Cookie Policy',
    cookiePolicyHref: '/terms-and-conditions',

    privacyPolicyLink: 'Privacy Policy',
    privacyPolicyHref: '/terms-and-conditions',

    tosLink: 'Terms of Service',
    tosHref: '/terms-and-conditions',
  }
};
export function HttpLoaderFactory(httpClient: HttpClient) {
  return new TranslateHttpLoader(httpClient, './assets/i18n/', '.json');
}

@NgModule({
  declarations: [
    AppComponent,
    AboutComponent,
    UserProfileComponent,
    SearchComponent,    
    LoginComponent,
    TeacherDetailsComponent,
    FaqComponent,
    SearchResultsComponent,
    HeaderComponent,
    FooterComponent,
    ProfileComponent,
    DashboardComponent,
    EnrollComponent,
    AssignmentComponent,
    AssessmentComponent,
    NoticeComponent,
    EnquiryComponent,
    ContentComponent,
    EnrolDetailsComponent,
    NoticeListComponent,
    NoticeDetailsComponent,
    ContentListComponent,
    ContentDetailsComponent,
    ClassSearchResultComponent,
    ViewSearchDetailsComponent,
    ViewSearchComponent,
    MyCoursesComponent,
    ClassDetailsComponent,
    RegistrationComponent,
    OtpComponent,
    MakeEnquriyComponent,
    MakeEnrollComponent,    
    ClassSearchDetailsComponent,
    HowitworksComponent,
    SuccessEnquriyComponent,
    AboutUsComponent,
    CalendarComponent,
    EnquiryDetailsComponent,
    ContactusComponent,
    TermsComponent,
    SidebarComponent,
    UsereditComponent, 
    HowItWorksTeacherComponent,
    AppDownloadComponent,
    DClsDtlsComponent,    
    CreatePostComponent,
    MyPostComponent,
    SuccessPostComponent,
    TeacherResponceComponent,
    HeaderComponent,
    FooterComponent,
    SuccessPostComponent,
    ForgotPasswordComponent,
    ChangePasswordComponent,
    HomeComponent,
    AssesmentDetailsComponent,
    AssignmentDetailsComponent,
    SubmissionDetailsComponent,
    SuccessEnrollComponent,
    HomeScreenNewComponent,
    AvailableClassesSliderComponent,
    HomeSearchFormComponent,
    ClassSearchResultNewComponent,
    SearchFiltersComponent,
    SearchListComponent,
    SearchItemsComponent,
    
    
    
  ],
  imports: [
    GooglePlaceModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    NgbModule,
    CarouselModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,   
    BrowserModule.withServerTransition({ appId: 'ngx-cookieconsent-demo-id' }),
    TransferHttpCacheModule,
    FormsModule,
    CookieLawModule,
    HttpClientModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    NgcCookieConsentModule.forRoot(cookieConfig),
    AppRoutingModule ,
    CommonModule,
    
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: environment.production,
      // Register the ServiceWorker as soon as the app is stable
      // or after 30 seconds (whichever comes first).
      registrationStrategy: 'registerWhenStable:30000'
    })    
  ],
  providers: [CookieService],
  bootstrap: [AppComponent]
})
export class AppModule { }
